<template>
  <div class="card-body p-0">
    <div class="subheading mb-7">
      <span class="subheading-dot" />
      <span class="subheading-text">
        {{ t('service_tags') }}
      </span>
    </div>
    <div
      v-show="serviceIntroduction"
      id="service-introduction"
      class="mb-7"
    >
      <span
        class="word-wrap font-middle preview-text"
        v-text="serviceIntroduction"
      />
    </div>
    <div
      v-if="serviceTags.length > 0"
      id="service-tags"
      class="flex-1 mb-n2"
    >
      <inline-tags-list :tags-array="serviceTags" />
    </div>
    <p
      v-else
      id="service-tags"
      class="btn-group text-gray03"
    >
      {{ t('unsettled') }}
    </p>
  </div>
</template>

<script>
import InlineTagsList from "../companies/InlineTagsList.vue";
import "../../i18n/ja";
import { i18n } from "../../mixins/i18n";

export default {
  components: { InlineTagsList },
  mixins: [i18n],
  props: {
    serviceTags: {
      type: Array,
      default() {
        return [];
      }
    },
    serviceIntroduction: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.word-wrap {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.font-middle {
  line-height: 28.8px;
}
</style>
